import React from 'react';
import { ArrowRight } from 'lucide-react';
import PackageCarousel from './PackageCarousel';
import { usePackages, useSettings, getIndia } from '../store';

const IndiaTourPackages = () => {
  const { packages } = usePackages();
  const settings = useSettings();
  const items = getIndia(packages);

  return (
    <section className="py-14">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">
              {(() => {
                const t = settings.section_india_title || 'India Tour Packages';
                const parts = t.split(' ');
                if (parts.length < 2) return <>{t}</>;
                return (
                  <>
                    {parts[0]} <span className="text-[#0d64a8]">{parts[1]}</span> {parts.slice(2).join(' ')}
                  </>
                );
              })()}
            </h2>
            <p className="text-sm text-gray-500 mt-1 italic">Bharat ke rang, Travelsera ke sang.</p>
          </div>
          <a href="#" className="flex items-center gap-2 text-[#0d64a8] font-medium text-sm hover:gap-3 transition-all">
            View All <ArrowRight size={16} />
          </a>
        </div>

        <PackageCarousel items={items} />
      </div>
    </section>
  );
};

export default IndiaTourPackages;
